<template>
    <el-row type="flex" class="flex-column" >
        <el-col class="flex-column" style="min-height:100vh;">
            <el-row style="height: 80px;background: #fff;position: relative;z-index: 10;">
                <el-col :md="{span:22,offset:1}" :lg="{span:20,offset:2}" >
                    <NavBar @changeTab="changeTab"></NavBar>
                </el-col>
            </el-row>
            <el-row class="flex-column flex1" >
                <el-col  class="flex-column flex1" >
                    <router-view name="main" ></router-view>
                </el-col>
            </el-row>
            <el-row>
                <el-col >
                    <FooterBar></FooterBar>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>

<script>
import { mapState } from 'vuex';
import NavBar from '@/components/navBar.vue';
import FooterBar from '@/components/footerBar.vue';

export default {
    data() {
        return {

        }
    },
    components: {
        NavBar,
        FooterBar
    },
    computed: {
        ...mapState([
            'userInfos',
        ]),
    },
    methods: {
        changeTab(e,item) {

            let path = "";

            if(this.userInfos.role == 0){
                path = item.routerPath;
            }else if(this.userInfos.role == 1) {
                path = item.routerPath1;
            }


            this.$router.push({
                path: path
            })
            
			// if(e==0)
			// {
			// 	//首页
			// 	this.$router.push({
			// 	    path: "/home",
			// 	    query: {
			// 	        Id: 10
			// 	    }
			// 	}).catch(e => e)
			// }else if(e==1)
			// {
			// 	this.$router.push({
			// 	    path: "/day_practice",
			// 	}).catch(e => e)
			// }else if(e==2)
			// {
			// 	this.$router.push({
			// 	    path: "/vocabulary_test",
			// 	}).catch(e => e)
			// }
        }
    }
}
</script>

<style lang="scss" scoped></style>